/* Keep Weglot as the translation service; use the theme's native country panel UI. */
(function () {
  'use strict';
  var replaying = false;
  var sequence = 0;
  var boundWeglot;
  var states = new Map();

  function popovers() {
    // Mobile panels are temporarily moved to body by the theme.
    return Array.from(document.querySelectorAll('x-popover[id^="popover-localization-"]'));
  }

  function sync(state, language) {
    var current = language || window.Weglot.getCurrentLang();
    var option = state.options.find(function (item) { return item.code === current; });
    if (!option) return;
    if (state.label.textContent !== option.name) state.label.textContent = option.name;
    state.panel.querySelectorAll('[data-language-code]').forEach(function (button) {
      var selected = String(button.dataset.languageCode === current);
      if (button.getAttribute('aria-selected') !== selected) button.setAttribute('aria-selected', selected);
    });
  }

  function enhance(group) {
    if (!window.Weglot || typeof window.Weglot.switchTo !== 'function' || typeof window.Weglot.getCurrentLang !== 'function') return;
    var source = group.querySelector('.weglot-container');
    if (!source) return;
    var options = [];
    source.querySelectorAll('.language-option a[lang]').forEach(function (link) {
      var code = link.getAttribute('lang');
      if (!options.some(function (item) { return item.code === code; })) options.push({code: code, name: link.textContent.trim()});
    });
    if (options.length < 2) return;
    var countryTrigger = group.querySelector('.auteur-localization__trigger');
    if (!countryTrigger) return;
    var state = states.get(group);
    if (!state) {
      var wrapper = document.createElement('div');
      wrapper.className = 'relative auteur-localization auteur-language';
      wrapper.setAttribute('data-wg-notranslate', 'true');
      var trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'h-stack gap-2 auteur-localization__trigger';
      trigger.setAttribute('aria-expanded', 'false');
      var label = document.createElement('span');
      label.className = 'subheading';
      trigger.appendChild(label);
      var chevron = countryTrigger.querySelector('svg');
      if (chevron) trigger.appendChild(chevron.cloneNode(true));
      // Parse in an inert template so the native dialog upgrades after its content exists.
      var template = document.createElement('template');
      template.innerHTML = '<x-popover></x-popover>';
      var panel = template.content.firstElementChild;
      panel.id = 'popover-localization-weglot-' + (++sequence);
      panel.className = 'popover auteur-localization__popover auteur-language__popover color-scheme';
      panel.setAttribute('preferred-position', 'above');
      panel.setAttribute('data-wg-notranslate', 'true');
      trigger.setAttribute('aria-controls', panel.id);
      var title = document.createElement('p');
      title.slot = 'header';
      title.className = 'subheading';
      title.textContent = group.dataset.languageLabel || 'Language';
      var list = document.createElement('div');
      list.className = 'popover__value-list';
      list.setAttribute('role', 'listbox');
      list.setAttribute('aria-label', title.textContent);
      panel.append(title, list);
      wrapper.append(trigger, panel);
      state = {wrapper: wrapper, trigger: trigger, label: label, panel: panel, list: list, options: [], signature: ''};
      states.set(group, state);
      group.appendChild(wrapper);
      panel.addEventListener('click', function (event) {
        var button = event.target.closest('[data-language-code]');
        if (!button) return;
        event.preventDefault();
        var code = button.dataset.languageCode;
        Promise.resolve(panel.hide()).then(function () {
          if (code !== window.Weglot.getCurrentLang()) window.Weglot.switchTo(code);
          sync(state);
        });
      });
    }
    var signature = JSON.stringify(options.slice().sort(function (a, b) { return a.code.localeCompare(b.code); }));
    if (signature !== state.signature) {
      state.signature = signature;
      state.options = options;
      state.list.replaceChildren();
      options.forEach(function (item) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'popover__value-option subheading';
        button.dataset.languageCode = item.code;
        button.setAttribute('role', 'option');
        button.setAttribute('lang', item.code);
        button.textContent = item.name;
        state.list.appendChild(button);
      });
    }
    sync(state);
    source.setAttribute('data-auteur-native', '');
    if (boundWeglot !== window.Weglot && typeof window.Weglot.on === 'function') {
      boundWeglot = window.Weglot;
      window.Weglot.on('languageChanged', function (language) {
        states.forEach(function (item, owner) { if (owner.isConnected) sync(item, language); });
      });
      window.Weglot.on('switchersReady', scan);
    }
  }

  function scan() {
    document.querySelectorAll('.auteur-footer-localization').forEach(function (group) {
      if (!group.hasAttribute('data-auteur-observed')) {
        group.setAttribute('data-auteur-observed', '');
        new MutationObserver(function () { enhance(group); }).observe(group, {childList: true, subtree: true});
      }
      enhance(group);
    });
  }

  document.addEventListener('click', function (event) {
    if (replaying || !(event.target instanceof Element)) return;
    var trigger = event.target.closest('.auteur-localization__trigger');
    if (!trigger) return;
    var targetId = trigger.getAttribute('aria-controls');
    var open = popovers().filter(function (panel) { return panel.open && panel.id !== targetId; });
    if (!open.length) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    Promise.all(open.map(function (panel) { return panel.hide(); })).then(function () {
      replaying = true;
      trigger.focus({preventScroll: true});
      trigger.click();
      replaying = false;
    });
  }, true);

  document.addEventListener('dialog:before-show', function (event) {
    var dialog = event.target;
    if (!(dialog instanceof Element)) return;
    if (dialog.id.startsWith('popover-localization-') || dialog.matches('header-mega-menu, header-dropdown-menu, header-menu-drawer, cart-drawer, search-drawer')) {
      popovers().forEach(function (other) { if (other !== dialog && other.open) other.hide(); });
    }
  }, true);

  function ready() {
    customElements.whenDefined('x-popover').then(function () {
      scan();
      // Weglot and Shopify can insert their controls after the theme initializes.
      new MutationObserver(scan).observe(document.body, {childList: true});
      document.addEventListener('shopify:section:load', scan);
      window.addEventListener('load', scan, {once: true});
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, {once: true});
  else ready();
})();
